export default __webpack_public_path__ + "static/media/B67.f7965214.png";